import React from "react";
import {
  Show,
  SimpleShowLayout,
  TextField,
  DateField,
  BooleanField,
  SelectField,
  ArrayField,
  Datagrid,
  UrlField,
} from "react-admin";
import { Typography } from "@mui/material";

import { languageChoices, buyerProfileType, dateOptions } from "../../../../utils/options";

const ShowBuyerProfiles = () => {
  return (
    <Show title="Детайли за профил">
      <SimpleShowLayout>
        <SelectField
          label="Език"
          source="language"
          choices={languageChoices}
        />
        <SelectField
          label="Тип обява"
          source="buyer_profile_type"
          choices={buyerProfileType}
          fullWidth
        />
        <TextField
          label="Заглавие"
          source="title"
        />
        <DateField
          label="Дата на публикуване"
          source="started_on"
          locales={"bg"}
          options={dateOptions}
        />

        <BooleanField
          label="Скрита"
          source="is_hidden"
        />

        <Typography>Качени файлове</Typography>
        <ArrayField
          label=""
          source="buyer_profile_files"
        >
          {" "}
          <Datagrid
            bulkActionButtons={false}
            empty={<Typography sx={{ marginBottom: "40px", fontSize: ".8rem" }}>Няма зададени</Typography>}
          >
            <TextField
              label="Име на файл"
              source="name"
            />
            <UrlField
              label="Линк"
              source="url"
            />
          </Datagrid>
        </ArrayField>
      </SimpleShowLayout>
    </Show>
  );
};
export default ShowBuyerProfiles;
